<div class="container">
    <div class="my-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a [routerLink]="APP_ROUTES.INDEX">{{ NAVS.INDEX }}</a></li>
                <li class="breadcrumb-item active"
                    aria-current="page">{{ template?.data.page?.breadcrumb || NAVS.AGREEMENT.INDEX }}
                </li>
            </ol>
        </nav>
    </div>

    <h1 class="mb-3">{{ template?.data.page?.h1 || NAVS.AGREEMENT.INDEX }}</h1>

    <section class="mb-4">
        <p>
            Настоящее Пользовательское соглашение регулирует порядок использования сайта и сервиса MotorDesk,
            доступного по адресу {{ env.URL_FRONT }} и связанных с ним разделов, включая личный кабинет, демо-режим
            и интеграции сервиса.
        </p>
        <p>
            Использование сайта, регистрация аккаунта, авторизация, использование личного кабинета, Telegram-бота
            и иных функций сервиса означает полное и безоговорочное принятие условий настоящего Соглашения.
            Если пользователь не согласен с условиями Соглашения, он обязан немедленно прекратить использование сервиса.
        </p>
        <p>
            MotorDesk предоставляет сервис в статусе внедрения и развития. На момент публикации настоящей редакции
            состав доступных функций и действующие ограничения определяются Администрацией.
        </p>
    </section>

    <section class="mb-4">
        <h2>1. Статус сервиса и условия доступа</h2>
        <ul>
            <li>Сервис предоставляется по модели <b>“как есть”</b> и <b>“по мере доступности”</b>.</li>
            <li>Администрация определяет состав доступных функций, лимиты, объем хранения данных и иные условия
                использования сервиса.
            </li>
            <li>Администрация вправе изменять доступные функции, порядок доступа, условия
                регистрации и использования сервиса без предварительного согласования с пользователем.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>2. Аккаунт и доступ</h2>
        <ul>
            <li>Для доступа к ряду функций пользователю может потребоваться регистрация аккаунта.</li>
            <li>Пользователь обязан предоставлять достоверные, актуальные и законно используемые данные при регистрации
                и использовании сервиса.
            </li>
            <li>Пользователь самостоятельно отвечает за сохранность логина, пароля, кодов доступа, устройств и иных
                средств аутентификации.
            </li>
            <li>Все действия, совершенные с использованием аккаунта пользователя, считаются совершенными самим
                пользователем, пока не доказано иное.
            </li>
            <li>Администрация вправе отказать в регистрации, ограничить доступ, временно приостановить или удалить
                аккаунт при нарушении Соглашения, подозрении на злоупотребление, угрозе безопасности сервиса или по иным
                обоснованным причинам.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>3. Обязанности пользователя</h2>
        <p>Пользователь обязуется:</p>
        <ul>
            <li>использовать сервис только законным способом и не нарушать права третьих лиц;</li>
            <li>не размещать в сервисе заведомо ложные, незаконные, вредоносные, оскорбительные или нарушающие чужие
                права данные;
            </li>
            <li>не вводить в сервис персональные данные третьих лиц без надлежащих правовых оснований и необходимых
                согласий;
            </li>
            <li>самостоятельно проверять корректность и актуальность введенных данных об автомобилях, расходах, пробеге,
                заправках, обслуживании, сервисных точках и иных событиях;
            </li>
            <li>самостоятельно создавать резервные копии важных для него данных, если такие данные имеют для него
                существенную ценность;
            </li>
            <li>не использовать сервис для обхода ограничений, автоматизированного несанкционированного сбора данных,
                атак, перегрузки инфраструктуры, подбора учетных данных и иных недобросовестных действий;
            </li>
            <li>не передавать доступ к своему аккаунту третьим лицам, если это прямо не разрешено Администрацией.</li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>4. Права Администрации</h2>
        <p>Администрация вправе без согласования с пользователем:</p>
        <ul>
            <li>изменять интерфейс, архитектуру, состав функций, лимиты, сценарии работы, состав интеграций и
                иные элементы сервиса;
            </li>
            <li>временно приостанавливать работу сервиса или его отдельных разделов для обновления, обслуживания,
                устранения сбоев, защиты от угроз и по иным техническим причинам;
            </li>
            <li>ограничивать доступ к сервису полностью или частично;</li>
            <li>удалять, скрывать, блокировать или ограничивать доступ к данным, если это требуется по закону, для
                защиты сервиса, по жалобе правообладателя, при нарушении Соглашения или по иным разумным основаниям;
            </li>
            <li>вводить новые правила пользования, специальные условия для отдельных функций и дополнительные документы,
                обязательные для пользователя;
            </li>
            <li>направлять пользователю сервисные уведомления, связанные с безопасностью, доступом, регистрацией,
                изменением правил, интеграций и условий работы сервиса.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>5. Права на сервис и пользовательские данные</h2>
        <ul>
            <li>Исключительные права на сайт, сервис, программный код, дизайн, структуру, базы данных, тексты, графику,
                товарные обозначения и иные элементы сервиса принадлежат Администрации либо используются ею на законных
                основаниях.
            </li>
            <li>Пользователь не приобретает никаких прав на сервис, кроме ограниченного, отзывного, неисключительного
                права использования его в пределах, прямо предусмотренных Соглашением и интерфейсом сервиса.
            </li>
            <li>Пользователь сохраняет права на введенные им данные, однако предоставляет Администрации право хранить,
                обрабатывать, отображать, систематизировать, копировать и иным образом использовать такие данные в
                объеме, необходимом для работы сервиса, обеспечения его безопасности, развития, поддержки и защиты прав
                Администрации.
            </li>
            <li>Если пользователь размещает сведения, относящиеся к третьим лицам, он самостоятельно несет
                ответственность за наличие законных оснований для такой обработки и размещения.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>6. Отсутствие гарантий</h2>
        <p>Администрация не гарантирует и прямо не обещает:</p>
        <ul>
            <li>непрерывную, безошибочную и бесперебойную работу сервиса;</li>
            <li>сохранение любого объема пользовательских данных в течение конкретного срока;</li>
            <li>пригодность сервиса для конкретной цели пользователя, коммерческого результата, налогового,
                бухгалтерского, технического или иного учета;
            </li>
            <li>совместимость сервиса со всеми устройствами, браузерами, операционными системами, внешними сервисами и
                каналами связи;
            </li>
            <li>отсутствие ошибок, уязвимостей, сбоев, задержек, потери данных или временной недоступности отдельных
                функций.
            </li>
        </ul>
        <p>
            Любые сведения, расчеты, напоминания, аналитика, подсказки и визуализации в сервисе носят информационный
            характер и не являются профессиональной консультацией, финансовой, налоговой, юридической, технической или
            иной гарантированной рекомендацией.
        </p>
    </section>

    <section class="mb-4">
        <h2>7. Ограничение ответственности</h2>
        <ul>
            <li>Пользователь использует сервис на свой риск.</li>
            <li>В максимально допустимой законом степени Администрация не отвечает за любые прямые или косвенные убытки,
                упущенную выгоду, потерю данных, простой, потерю деловой репутации, ошибки в пользовательских данных,
                неверные действия пользователя на основании сведений из сервиса и иные неблагоприятные последствия
                использования или невозможности использования сервиса.
            </li>
            <li>Администрация не отвечает за содержание, действия, политику, доступность и безопасность сторонних
                сервисов, платформ, провайдеров связи, почтовых сервисов, Telegram, captcha-провайдеров,
                хостинг-провайдеров и иных третьих лиц.
            </li>
            <li>Администрация не несет ответственности за утрату доступа к аккаунту, если это произошло вследствие
                действий или бездействия пользователя, компрометации его учетных данных, устройства, почтового ящика или
                мессенджера.
            </li>
            <li>Администрация не несет ответственности за удаление, изменение, искажение, недоступность или потерю
                данных, если иное прямо не предусмотрено обязательными нормами закона.
            </li>
            <li>При любых обстоятельствах, если ответственность Администрации все же будет признана, она ограничивается
                реальным документально подтвержденным ущербом в пределах, допускаемых применимым законодательством.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>8. Внешние сервисы и интеграции</h2>
        <ul>
            <li>Сервис может использовать или отображать ссылки, интеграции и технические зависимости третьих лиц.</li>
            <li>При подключении Telegram-бота, переходе по внешним ссылкам, использовании captcha, почтовых сервисов или
                иных внешних решений пользователь также вступает во взаимодействие с соответствующими третьими лицами на
                их условиях.
            </li>
            <li>Администрация не контролирует полностью работу сторонних сервисов и не отвечает за их доступность,
                изменения правил, блокировки, ограничения, сбои и последствия таких обстоятельств для пользователя.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>9. Изменение, приостановление и прекращение доступа</h2>
        <ul>
            <li>Администрация вправе в любой момент изменить, ограничить, приостановить или прекратить работу сервиса
                полностью или частично.
            </li>
            <li>Администрация вправе удалить аккаунт пользователя, ограничить доступ к функциям, архивировать или
                удалить данные при нарушении Соглашения, угрозе безопасности, длительной неактивности, прекращении
                проекта или по иным законным и разумным основаниям.
            </li>
        </ul>
    </section>

    <section class="mb-4">
        <h2>10. Изменение Соглашения</h2>
        <p>
            Администрация вправе в одностороннем порядке изменять настоящее Соглашение в любое время. Новая редакция
            вступает в силу с момента ее публикации по адресу {{ env.URL_FRONT }}{{ APP_ROUTES.AGREEMENT.INDEX }}, если
            иной срок не указан дополнительно.
        </p>
        <p>
            Продолжение использования сервиса после публикации новой редакции Соглашения означает согласие пользователя
            с такими изменениями.
        </p>
    </section>

    <section class="mb-4">
        <h2>11. Применимое право и связь с Администрацией</h2>
        <p>
            К настоящему Соглашению применяется право Российской Федерации. По вопросам использования сервиса
            пользователь
            может обратиться по адресу электронной почты admin&#64;motordesk.ru.
        </p>
    </section>
</div>
